import { render, staticRenderFns } from "./BulkBlockNumbers.vue?vue&type=template&id=63367b2c&scoped=true"
import script from "./BulkBlockNumbers.vue?vue&type=script&lang=js"
export * from "./BulkBlockNumbers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63367b2c",
  null
  
)

export default component.exports